export default "__VITE_ASSET__BYMDWTwz__"